import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router';
import { NavRibbon, NavRibbonLink } from '../../../../components/nav-ribbon/NavRibbon';
import { PageContent } from '../../../../components/page-components/PageContent';
import { hasPermission } from '../../../../containers/authorization-helpers/has-permission';
import { RequirePermission } from '../../../../containers/authorization-helpers/RoutePermission';
import { IApplicationState } from '../../../../store/IApplicationState';
import { PageNames, Routes } from '../../../../utils/app-constants';
import { updateSelectedShipmentsTab } from '../../../../transportation/actions';
import '../../../../transportation/styles.scss';
import { CommunicationsTrucksScene } from './CommunicationsTrucks';
import { CommunicationsContainersScene } from './CommunicationsContainers';


export const CommunicationsScene = (props: IBaseSceneProps) => {

    const dispatch = useDispatch();
    const storedPath = useSelector((state: IApplicationState) => state.transportation.selectedCommunictionsTab);
    const [currentLocation, setCurrentLocation] = React.useState('');

    // We want to track the current tab we're showing
    React.useEffect(() => {
        if (props.location.pathname !== currentLocation) {
            /*reset();*/
            _persistTab();
        }
    }, [props.location]);

    const _persistTab = () => {

        setCurrentLocation(props.location.pathname);

        let p = '';
        if (document.location.pathname.endsWith(Routes.SHIPPING_TRUCKS)) {
            p = Routes.SHIPPING_TRUCKS;
        }
        else if (document.location.pathname.endsWith(Routes.SHIPPING_CONTAINERS)) {
            p = Routes.SHIPPING_CONTAINERS;
        }
        else if (storedPath) {
            p = storedPath;
        }

        dispatch(updateSelectedShipmentsTab(p));
    };

    /**
     * This handles checking the current user permissions to determine what the default 
     * path should be
     */
    const getRedirectPath = () => {

        const tPerm = Permissions.CommunicationsShipmentsTrucksView;
        const cPerm = Permissions.CommunicationsShipmentsContainersView;

        if (hasPermission({ requiredPermissions: [tPerm] })) {
            return Routes.COMMUNICATIONS_SHIPMENTS_TRUCKS;
        }
        else if (hasPermission({ requiredPermissions: [cPerm] })) {
            return Routes.COMMUNICATIONS_SHIPMENTS_CONTAINERS;
        }

        return '/';
    };

    return <PageContent pageName={PageNames.TRANSPORTATION_FLEET}>
        <NavRibbon links={[
            new NavRibbonLink(
                Routes.COMMUNICATIONS_SHIPMENTS_TRUCKS,
                'la-truck',
                'Trucks',
                [Permissions.CommunicationsShipmentsTrucksView]
            ),
            new NavRibbonLink(
                Routes.COMMUNICATIONS_SHIPMENTS_CONTAINERS,
                'la-cubes',
                'Containers',
                [Permissions.CommunicationsShipmentsContainersView]
            )
        ]} />

        <Switch>

            <Route
                key="transportation-communications-trucks"
                exact={true}
                path={Routes.COMMUNICATIONS_SHIPMENTS_TRUCKS}
                render={
                    RequirePermission(() =>
                        <CommunicationsTrucksScene
                        />,
                        [
                            Permissions.CommunicationsShipmentsTrucksView
                        ]
                    )
                }
            />

            <Route
                key="transportation-communications-containers"
                exact={true}
                path={Routes.COMMUNICATIONS_SHIPMENTS_CONTAINERS}
                render={
                    RequirePermission(() =>
                        <CommunicationsContainersScene
                        />,
                        [
                            Permissions.CommunicationsShipmentsContainersView
                        ]
                    )
                }
            />

            <Redirect
                key="transportation-communications-redirect"
                exact={true}
                from={Routes.COMMUNICATIONS_SHIPMENTS}
                to={storedPath ? storedPath : getRedirectPath()} />

        </Switch>
    </PageContent>;
};
